import React, {useCallback, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {Descriptions, Modal, Table, Tag, Button} from 'antd';
import dayjs from 'dayjs';
import {getPushHistoryDetail, retryPush} from '@/api/hrPush';
import {message} from 'antd';

export default function HistoryDetailModal({appId, historyId, taskName, onClose}) {
    const [data, setData] = useState();
    const [pagination, setPagination] = useState({current: 1, size: 10, total: 0});

    const load = useCallback(
        async (current = 1) => {
            const json = await getPushHistoryDetail(appId, historyId, {
                current,
                size: pagination.size,
            });
            setData(json.data);
            setPagination(old => ({
                ...old,
                current,
                total: json.data?.targets?.total || 0,
            }));
        },
        [appId, historyId, pagination.size]
    );

    useEffect(() => {
        if (historyId) load(1);
    }, [historyId, load]);

    const retry = async targetId => {
        await retryPush(appId, historyId, targetId);
        message.success('重推完成');
        load(pagination.current);
    };

    const columns = [
        {title: '姓名', dataIndex: 'userName'},
        {title: '员工号', dataIndex: 'employeeNumber'},
        {title: '角色', dataIndex: 'position', render: value => value || '-'},
        ...(data?.history?.taskType === 'points_reminder'
            ? [
                  {
                      title: '积分截止日',
                      dataIndex: 'pointsExpireDate',
                      render: value => (value ? dayjs(value).format('YYYY-MM-DD') : '-'),
                  },
                  {
                      title: '剩余积分',
                      dataIndex: 'remainingPoints',
                      render: value => (value == null ? '-' : value),
                  },
              ]
            : []),
        {
            title: '发送状态',
            dataIndex: 'pushStatus',
            render: value => (
                <Tag color={value === 1 ? 'green' : 'red'}>{value === 1 ? '● 成功' : '● 失败'}</Tag>
            ),
        },
        {
            title: '错误信息',
            dataIndex: 'errorMessage',
            render: value => value || '-',
        },
        {
            title: '操作',
            width: 80,
            render: (_, row) =>
                row.pushStatus === 1 ? null : (
                    <Button type="link" onClick={() => retry(row.id)}>
                        重推
                    </Button>
                ),
        },
    ];

    return (
        <Modal open={!!historyId} title="推送日志详情" footer={null} width={800} onCancel={onClose}>
            <Descriptions size="small" bordered column={2} style={{marginBottom: 16}}>
                <Descriptions.Item label="任务名称">{taskName}</Descriptions.Item>
                <Descriptions.Item label="发送总人数">
                    {data?.history?.targetCount || 0}人
                </Descriptions.Item>
                <Descriptions.Item label="成功">
                    {data?.history?.successCount || 0}
                </Descriptions.Item>
                <Descriptions.Item label="失败">{data?.history?.failCount || 0}</Descriptions.Item>
            </Descriptions>
            <Table
                rowKey="id"
                columns={columns}
                dataSource={data?.targets?.records || []}
                scroll={{x: data?.history?.taskType === 'points_reminder' ? 980 : 760}}
                pagination={{
                    current: pagination.current,
                    total: pagination.total,
                    pageSize: pagination.size,
                    onChange: load,
                }}
            />
        </Modal>
    );
}

HistoryDetailModal.displayName = 'HistoryDetailModal';

HistoryDetailModal.propTypes = {
    appId: PropTypes.string.isRequired,
    historyId: PropTypes.string,
    taskName: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
};

HistoryDetailModal.defaultProps = {
    historyId: null,
};
